import {
  CircularProgress,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Left from '@material-ui/icons/ChevronLeft';
import {IRegisterForm} from 'packages/common-types/base-types';
import useAppAuth from 'packages/hooks/use-app-auth';
import useRegister from 'packages/hooks/use-register';
import useRouter from 'packages/hooks/use-router';
import {FormProvider, useForm} from 'react-hook-form';
import useCommonStyles from 'packages/common-utils/common-styles';
import clsx from 'clsx';
import {Redirect} from 'react-router-dom';
import registerImage from 'packages/assets/images/registerImage.jpg';
import RegisterForm from './Form';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'grid',
  },
  left: {
    position: 'relative',
    backgroundImage: `url(${registerImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    background: 'linear-gradient(26.82deg, #39C6C6 -24.85%, #2c91382b 98.25%)',
  },
  rightSide: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: theme.spacing(5, 5),
  },
  registerTitle: {
    margin: 0,
    fontSize: 31,
    fontWeight: 700,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(2),
    width: '100%',
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(8),
  },
}));

const Register = () => {
  const classes = useStyles();
  const methods = useForm<IRegisterForm>({
    mode: 'onBlur',
    defaultValues: {
      city: '',
      clubName: '',
    },
  });
  const {history} = useRouter();
  const auth = useAppAuth();
  const {loading: creatingUser, onSubmit} = useRegister();
  const theme = useTheme();
  const common = useCommonStyles();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  if (auth?.authenticated && auth.isAdmin) return <Redirect to="/admin" />;
  if (auth?.authenticated && !auth.isAdmin) return <Redirect to="/app" />;

  return (
    <FormProvider {...methods}>
      <div
        className={clsx([
          classes.root,
          matches ? common.fullRow : common.sideBySide,
        ])}
      >
        <div className={classes.left}>
          <div className={classes.backdrop} />
        </div>
        <div className={classes.rightSide}>
          <div className={classes.column}>
            <Button
              onClick={() => history.replace('/')}
              style={{textTransform: 'none', width: '150px'}}
              startIcon={<Left />}
              name="back-btn"
              variant="text"
            >
              Ya tengo cuenta
            </Button>
            <h1 className={classes.registerTitle}>Crear una cuenta</h1>
            <Typography color="textSecondary" variant="h6">
              Empieza a participar en los torneos que haga la fundación
            </Typography>
          </div>
          <div className={classes.content}>
            <RegisterForm submitting={creatingUser} onSubmit={onSubmit} />
            <Button
              form="create-account-form"
              style={{marginTop: 35}}
              disableElevation
              fullWidth
              name="btn-register"
              type="submit"
              size="medium"
              variant="contained"
              color="primary"
            >
              {creatingUser ? (
                <CircularProgress color="secondary" size={24} />
              ) : (
                `Crear mi cuenta`
              )}
            </Button>
          </div>
        </div>
      </div>
    </FormProvider>
  );
};

export default Register;
